import * as yup from "yup";

let CalculateFeeSchema = yup.object().shape({
  amount: yup.number().required("Amount is required"),
});

export default CalculateFeeSchema;
